import script from "./HeaderNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderNotification.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderNotification.vue?vue&type=style&index=0&id=35e06dd8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35e06dd8"]])

export default __exports__